import type { HttpPost } from '@/shared/infra/http'
import type { CompleteOnboarding } from '@/modules/auth/use-cases'

export class EdgeCompleteOnboardingRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: CompleteOnboarding = async () => {
    await this.httpClient.post<Record<string, never>, unknown>({
      url: '/users/complete-onboarding',
      body: {},
    })
  }
}
